module.exports = __webpack_public_path__ + "static/media/Dr-Agustín-Morbelli.874c207e.jpg";